// extracted by mini-css-extract-plugin
export default {"container":"styleModule_container__JvlwG","icon":"styleModule_icon__a2fy0","title":"styleModule_title__nC4Qa","subtitle":"styleModule_subtitle__AXzjv"};